import {
  Button,
  CircularProgress,
  DialogContent,
  Grid,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { DatePicker } from "material-ui-pickers";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from "moment";
import "moment/locale/pt-br";
import React, { Component } from "react";
import PassengerService from "../../../tools/PassengerService";
//Fix the css
import { msgAction } from "../../../actions/snackbarActions";
import { connect } from "react-redux";
import { msgSimple } from "../../../actions/snackbarActions";
import MultiSelect from "../../../components/MultiSelect";
import FlightStageService from "../../../tools/FlightStageService";
import "../style.css";

import PassengersModal from "../../../routes/settings/passengers/Modal.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Dialog } from "react-bootstrap/lib/Modal.js";

const MySwal = withReactContent(Swal);

class ModalMissionV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openPax: false,
      modalPax: { id: "new" },
      loading: false,
      modal: {
        from: "",
        to: "",
        date: "",
        local_time: null,
        passengers_summary: "",
        observations: "",
        origin: "",
        destination: "",
        passengers: [],
      },
      minDate: null,
      passengers: [],
      selectedPassengers: [],
      lastDestination: "",
      lastStep: null,
    };
  }

  handleRefreshState = async () => {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );
  };

  openPaxDialog = (value) => {
    if (value) {
      this.setState({ newPax: value });
    }
    this.setState({ openPax: !this.state.openPax });
  };

  handleClosePax = () => {
    this.setState({ openPax: !this.state.openPax });
  };

  handleSavePax = (item) => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then((result) => {
      console.log(item);
      if (!!result.value) {
        //Save user
        if (item.id === "new") {
          let { passengers } = this.state;
          passengers.push({ ...item });
          passengers.reverse();
          this.setState({ passengers });
          this.setState({ loading: true });
          delete item.id;
          PassengerService.create(item).then((result) => {
            if (result.ok) {
              this.handleRefreshState();
              this.props.msgSimple(
                item.first_name + " " + item.last_name + " criado com sucesso."
              );
            } else {
              let { passengers } = this.state;
              passengers = passengers.filter((e) => e.id !== "new");
              passengers.reverse();
              this.setState({ passengers });
              msgAction(
                'Erro ao criar "' +
                  item.first_name +
                  " " +
                  item.last_name +
                  '"',
                "TENTAR NOVAMENTE",
                () => this.handleSave(item)
              );
            }
          });
        }
        this.setState({ openPax: false, loading: false });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  _handleIdMultiSelect = async (value) => {
    if (value) {
      return await value.map((element) => {
        let label = [];
        label = label.concat(
          (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : "") +
            " - " +
            (element.cpf ? element.cpf : "")
        );
        return { value: element.id, label: label };
      });
    }
    return null;
  };

  onRender = async () => {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );

    if (this.props.modal.id === "new")
      this.setState({
        modal: {
          id: "new",
          from: this.props.modal.from,
          to: "",
          date: this.props.modal.date,
          local_time: null,
          passengers_summary: "",
          observations: "",
          origin: "",
          destination: "",
          passengers: [],
        },
        minDate: this.props.modal.date,
      });
    else {
      if (this.props.lastStep) {
        this.setState({
          minDate: this.props.lastStep.arrival_date,
        });
      } else {
        this.setState({
          minDate: null,
        });
      }
      if (this.props.modal.local_time) {
        let { local_time } = this.props.modal;
        let time = new Date();
        time.setHours(local_time.split(":")[0]);
        time.setMinutes(local_time.split(":")[1]);
        await this.setState({
          modal: { ...this.props.modal, local_time: time },
        });
      } else {
        await this.setState({ modal: { ...this.props.modal } });
      }

      FlightStageService.getById(this.props.modal.id).then(async (res) => {
        if (res.ok) {
          console.log(res.response);
          await this.setState({
            modal: {
              ...this.props.modal,
              passengers: await this._handleIdMultiSelect(
                res.response.passengers
              ),
            },
          });
        }
      });
    }
  };

  render() {
    return (
      <Modal
        open={this.props.openModal}
        onRendered={this.onRender}
        onClose={this.props.handleClose}
      >
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} style={styles.modal}>
          <Paper style={{ height: "100%", width: "100%", padding: 20 }}>
            <PassengersModal
              modal={this.state.modalPax}
              openModal={this.state.openPax}
              func={this.handleClosePax}
              handleSave={this.handleSavePax}
            />
            <Grid
              container
              item
              style={{ flex: 1 }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography variant="title" id="modal-title">
                Nova etapa
              </Typography>
            </Grid>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  id="from"
                  label="Origem"
                  style={{ width: "100%" }}
                  value={this.state.modal.from}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, from: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  id="to"
                  label="Destino"
                  style={{ width: "100%" }}
                  value={this.state.modal.to}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, to: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                  locale="pt-br"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    label="Data"
                    disablePast
                    format="DD/MM/YYYY"
                    cancelLabel="CANCELAR"
                    okLabel="SELECIONAR"
                    minDate={this.state.minDate}
                    value={this.state.modal.date}
                    onChange={(date) => {
                      let { modal } = this.state;
                      this.setState({ modal: { ...modal, date } });
                    }}
                    animateYearScrolling
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  id="time"
                  label="Hora"
                  type="time"
                  // defaultValue="00:00"
                  style={{ width: "100%" }}
                  value={this.state.modal.local_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, local_time: event.target.value },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
                {/* <MuiPickersUtilsProvider 
                                    utils={MomentUtils}
                                    moment={moment}
                                    locale='pt-br'
                                > 
                                    <TimePicker
                                        style={{width:'100%'}}
                                        label="Hora"
                                        clearable
                                        ampm={false}
                                        clearLabel='LIMPAR'
                                        cancelLabel='CANCELAR'
                                        okLabel='SELECIONAR'
                                        value={this.state.modal.local_time}
                                        onChange={local_time =>{
                                            let { modal } = this.state;
                                            this.setState({modal:{...modal, local_time}})
                                        }}
                                        animateYearScrolling
                                    />
                                </MuiPickersUtilsProvider>  */}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: true,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.passengers}
                  suggestions={this.state.passengers}
                  placeholder="Selecione os Passageiros"
                  label="Passageiros"
                  onChange={(value) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, passengers: value },
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ marginBottom: "20px" }}
              >
                <TextField
                  id="observations"
                  label="Observações"
                  style={{ width: "100%" }}
                  value={this.state.modal.observations}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, observations: event.target.value },
                    });
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                style={{ float: "left" }}
                onClick={() => {
                  // this.setState({
                  //   lastDestination: this.state.modal.destination,
                  // });
                  // console.log(this.state.lastDestination);
                  this.props.handleSave(this.state.modal);
                }}
                color="primary"
              >
                {this.props.modal.id === `new` ? `Salvar e Fechar` : `Salvar`}
              </Button>

              {this.props.modal.id === `new` && (
                <Button
                  style={{ float: "left" }}
                  onClick={() => {
                    this.props.handleSave(this.state.modal, true);
                  }}
                  color="primary"
                >
                  Adicionar nova etapa
                </Button>
              )}
              <Button
                style={{ float: "right" }}
                onClick={this.props.func}
                color="secondary"
              >
                Cancelar
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Modal>
    );
  }
}

const styles = {
  modal: {
    position: "absolute",
    top: "20%",
    left: "26%",
  },
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalMissionV2);



// WEBPACK FOOTER //
// ./src/routes/missions/mission-v2/Modal.js